var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorMsg } from '../../error-msg';
export var SubmitButtonField = function (_a) {
    var data = _a.data, buttonClickHandler = _a.buttonClickHandler;
    var handleKeyDown = function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            buttonClickHandler(data.field_type);
        }
    };
    return (_jsxs("div", __assign({ className: "col-xs-12" }, { children: [_jsx("div", __assign({ dir: "auto", className: 'button primary accentSecondary', onClick: function () { return buttonClickHandler(data.field_type); }, onKeyDown: handleKeyDown, role: "button", tabIndex: 0 }, { children: _jsx("span", __assign({ id: data.qid, className: data.className }, { children: data.value }), void 0) }), void 0), data.errorMessage && (_jsx(ErrorMsg, { id: data.qid, error: data.errorMessage }, void 0))] }), data.qid));
};
